import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';

export default function SuperAdminPage({ gcMe }) {
  const [nombre, setNombre] = useState('');
  const [direccion, setDireccion] = useState('');
  const [createdId, setCreatedId] = useState('');
  const [condominioIdAdmin, setCondominioIdAdmin] = useState('');
  const [adminEmail, setAdminEmail] = useState('');
  const [adminNombre, setAdminNombre] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  if (!gcMe?.isSuperAdminGc) {
    return <Navigate to="/condominios" replace />;
  }

  const createCondo = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    try {
      const { data } = await api.post('/gastos-comunes/condominios', { nombre, direccion });
      setCreatedId(data.id);
      setCondominioIdAdmin(data.id);
      setMsg(`Condominio «${data.nombre}» creado.`);
      setNombre('');
      setDireccion('');
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const assignAdmin = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    const cid = condominioIdAdmin.trim();
    if (!cid) {
      setError('Indica el ID del condominio');
      return;
    }
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/admin`, {
        email: adminEmail,
        nombre: adminNombre,
        password: adminPassword
      });
      setMsg('Administrador de condominio asignado.');
      setAdminEmail('');
      setAdminNombre('');
      setAdminPassword('');
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <div className="page-header">
        <h2>Super administración</h2>
        <p>Crear condominios y designar admin_condominio.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {msg && <div className="alert alert-success">{msg}</div>}
      <div className="card">
        <h3 className="card-title">Nuevo condominio</h3>
        <form onSubmit={createCondo}>
          <div className="field">
            <label>Nombre</label>
            <input value={nombre} onChange={(e) => setNombre(e.target.value)} required placeholder="Edificio Central" />
          </div>
          <div className="field">
            <label>Dirección</label>
            <input value={direccion} onChange={(e) => setDireccion(e.target.value)} placeholder="Calle y número" />
          </div>
          <button type="submit" className="btn">
            Crear condominio
          </button>
        </form>
        {createdId && (
          <p style={{ marginTop: '1rem', marginBottom: 0, fontSize: '0.8125rem', color: 'var(--gc-muted)' }}>
            ID reciente: <code>{createdId}</code>
          </p>
        )}
      </div>
      <div className="card">
        <h3 className="card-title">Asignar admin_condominio</h3>
        <form onSubmit={assignAdmin}>
          <div className="field">
            <label>ID condominio</label>
            <input
              value={condominioIdAdmin}
              onChange={(e) => setCondominioIdAdmin(e.target.value)}
              placeholder="MongoDB ObjectId"
              required
            />
          </div>
          <div className="field">
            <label>Email admin</label>
            <input type="email" value={adminEmail} onChange={(e) => setAdminEmail(e.target.value)} required />
          </div>
          <div className="field">
            <label>Nombre (solo si el usuario no existe)</label>
            <input value={adminNombre} onChange={(e) => setAdminNombre(e.target.value)} />
          </div>
          <div className="field">
            <label>Contraseña (solo usuario nuevo, mín. 6)</label>
            <input type="password" value={adminPassword} onChange={(e) => setAdminPassword(e.target.value)} />
          </div>
          <button type="submit" className="btn">
            Asignar administrador
          </button>
        </form>
      </div>
    </>
  );
}
